import {Component} from '@angular/core';
import {EnumPageDisplayModes, EnumPageEntitySources} from "../../../../../core/framework/sysenums.enum";
import {BaseEntity, BaseState} from "../../../../../base/entities/BaseEntities";
import {BasePageComponent} from "../../../../../base/component/BasePageComponent";
import {ServiceBagService} from "../../../../../base/component/ServiceBag";

class State extends BaseState {
}

@Component({
    selector: 'app-demo-simple-dialog',
    templateUrl: './demo-simple-dialog.component.html',
    styleUrls: ['../../../styles/demo-styles.scss']
})
export class DemoSimpleDialogComponent extends BasePageComponent<BaseEntity, State> {
    
    constructor(A: ServiceBagService) {
        super(A, 'DemoSimpleDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    protected override GetDefaultTitle(): string {
        return 'Simple dialog';
    }
}
